/**
 * Stepper du ComparateurFunnel — délègue au FunnelStepper commun
 * (barre de progression mobile + pastilles desktop).
 * S'adapte dynamiquement : l'étape « Usages » est masquée si aucun
 * profil sectoriel ne matche le code NAF du dossier.
 */
import { FunnelStepper } from '../../ui/funnel-stepper';
import {
  STEP_LABELS,
  getVisibleSteps,
  type FunnelStep,
  useComparateurStore,
} from './useComparateurStore';

interface StepperProps {
  currentStep: FunnelStep;
}

export function Stepper({ currentStep }: StepperProps) {
  const dossier = useComparateurStore((s) => s.dossier);
  const visible = getVisibleSteps(dossier);
  const stepperSteps = visible.map((step, i) => ({
    id: step,
    label: STEP_LABELS[step] ?? `Étape ${i + 1}`,
  }));
  // thank_you n'apparaît pas dans la barre : on reste sur la dernière étape visible
  // pour éviter d'annoncer « Étape 7 sur 6 » aux lecteurs d'écran.
  const currentIdx =
    currentStep === 'thank_you' ? visible.length - 1 : Math.max(0, visible.indexOf(currentStep));

  return (
    <div className="border-b border-stone-200 bg-stone-50/70 px-5 py-4 md:px-8">
      <FunnelStepper steps={stepperSteps} current={currentIdx} />
    </div>
  );
}
